import tronWeb from "tronweb";
import Client from "APIClient/APIClient.js";
import TronLinkClient from "WalletClient/TronlinkClient.js";
import {CONTRACT, TRONGRIDAPI, KEY} from 'constants.js';
import {getNftLelveByTokenId} from 'utils/utils.js'


const LocalTronWeb = new tronWeb({
    fullNode: TRONGRIDAPI,
    solidityNode: TRONGRIDAPI,
    eventServer: TRONGRIDAPI,
    privateKey: KEY
});

export const getBonus = async () => {
    try {
        let {data} = await Client.getBonus('0x' + TronLinkClient.tronWeb.defaultAddress.hex);
        if (data) {
            return {
                hit: data['data']['hit'],
                amount: data['data']['amount'],
            };
        } else {
            return {
                hit: false,
                amount: 0,
            };
        }
    } catch (e) {
        return {
            hit: false,
            amount: 0,
        };
    }
};

export const getQualification = async (address) => {
    try {
        let fortune = await Client.getAssets('0x' + address);
        let canClaim = await TronLinkClient.canClaim();

        let assets = fortune.data['assets'];
        let collections = fortune.data['collections'];

        let totalAssets = 0;
        let totalCollections = 0;

        assets.forEach((item) => {
            totalAssets = totalAssets + item['value'];
        });

        collections.forEach((item) => {
            totalCollections = totalCollections + item['value'];
        });

        return {
            rank: fortune.data['level'],
            canClaim: canClaim,
            signature: fortune.data['claim_sig'],
            assets: assets,
            assetsTotal: (totalAssets.toFixed(4)),
            collections: collections,
            collectionsTotal: (totalCollections.toFixed(4)),
            total: (totalAssets + totalCollections).toFixed(4),
            randomLevels: fortune.data['random_levels'] || [],
            network: TronLinkClient.tronWeb.fullNode.host === 'https://api.trongrid.io' ? 'main_net' : 'other'
        }
    } catch (e) {
        return {
            rank: -1,
            canClaim: false,
            signature: null,
            assets: [],
            assetsTotal: 0,
            collections: [],
            collectionsTotal: 0,
            total: 0,
            randomLevels: [],
            network: TronLinkClient.tronWeb.fullNode.host === 'https://api.trongrid.io' ? 'main_net' : 'other'
        }
    }
};

export const claim = async (level, signature) => {
    try {
        let hash = await TronLinkClient.claim(level, signature);
        return hash;
    } catch (e) {
        return {
            "error": true,
            "message": 'trigger_contract_failed'
        }
    }
};

export const getTokenID = async (hash) => {
    try {
        let data = await Client.getTokenID(hash);
        let token_id = data['event_list'][0]['result']['tokenId'];
        return token_id;
    } catch (e) {
        console.log(e);
        return null;
    }
};

export const getTXStatus = async (hash) => {
    try {
        let {contractRet} = await Client.getTXStatus(hash);
        return contractRet;
    } catch (e) {
        console.log(e);
        return null;
    }
};

export const getRemainedNFT = async () => {
    try {

        //  let data = await TronLinkClient.getClaimedStats();
        let contract = await LocalTronWeb.contract().at(CONTRACT);
        let data = await contract.claimedStats().call({_isConstant: true});

        let toDecimal = LocalTronWeb.toDecimal;
        let formatted = {
            legendaryCount: 10,
            epicCount: (90 - toDecimal(data['epicCount']['_hex'])) ? (90 - toDecimal(data['epicCount']['_hex'])) : 0,
            rareCount: (900 - toDecimal(data['rareCount']['_hex'])) ? (900 - toDecimal(data['rareCount']['_hex'])) : 0,
            regularCount: (9000 - toDecimal(data['ordinaryCount']['_hex'])) ? (9000 - toDecimal(data['ordinaryCount']['_hex'])) : 0,
        };

        return formatted;
    } catch (e) {
        return {
            legendaryCount: 0,
            epicCount: 0,
            rareCount: 0,
            regularCount: 0,
        };
    }
};

export const getMintRecord = async (address) => {
    let data1 = Client.getMintList(address);
    let data2 = Client.getBonousRes(address);

    return Promise.all([data1, data2]).then((result) => {

        const [res1, res2] = result

        let level = 0
        const tokenId = res1?.data?.rows?.token_id || ''

        level = getNftLelveByTokenId(tokenId)

        return {
            tokenId,
            amount: res2?.data?.amount || 0,
            level,
        }
    })
};



